import { type Framework } from '@toeverything/infra';

import { DocScope, DocService } from '../doc';
import { EditorScope, EditorService } from '../editor';
import { WorkspaceScope } from '../workspace';
import { WorkspaceDBService } from '../db';
import { AgentServiceBeta } from './services/agent-service-beta';
import { AgentStoreService } from './services/agent-store-service';
import { AgentBetaStore } from './stores/agent-store-beta';
import { SuggestionStoreBeta } from './stores/suggestion-store-beta';
import { SuggestionServiceBeta } from './services/suggestion-service-beta';
import { OrganizeService } from '../organize';

export { AgentServiceBeta } from './services/agent-service-beta';
export { AgentStoreService } from './services/agent-store-service';
export * from './services/suggestion-manager';
export * from './services/suggestion-service-beta';
export * from './types/index.d';
export * from './ui/suggestion-ui-manager';

// beta 版本: 支持多文档切换
export function configureYSAgentBetaModule(framework: Framework) {
  framework
    .scope(WorkspaceScope)
    // ✅ AgentBetaStore 现在需要 WorkspaceDBService 进行订阅
    .store(AgentBetaStore, [WorkspaceDBService])
    // ✅ AgentStoreService 处理所有写操作
    .service(AgentStoreService, [WorkspaceDBService, AgentBetaStore])
    // ✅ AgentServiceBeta 依赖 AgentStoreService
    .service(AgentServiceBeta, [AgentBetaStore, AgentStoreService, OrganizeService]);
}

// 注意需要在 DocScope 下获取
export function configureSuggestionBetaModule(framework: Framework) {
  framework
    .scope(WorkspaceScope)
    .scope(DocScope)
    .scope(EditorScope)
    .store(SuggestionStoreBeta)
    // ✅ SuggestionServiceBeta 依赖 AgentStoreService
    .service(SuggestionServiceBeta, [
      DocService,
      EditorService,
      SuggestionStoreBeta,
      AgentBetaStore,
      AgentStoreService,
    ]);
}
